import React from 'react';
import PropTypes from 'proptypes';

const ApplicationTermsAndConditionsModal = ({ closeModal }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <div className="row">
      <div className="col-md-12">
        <h2>TERMS AND CONDITIONS</h2>
        <p>
          "<strong>Applicant</strong>" - means a specific person who completed and submitted a GIVE
          Application
        </p>
        <p>
          "<strong>Participant</strong>" - means a specific person accepted to volunteer with GIVE
          and registers for a trip.
        </p>

        <h3>ACCEPTANCE CRITERIA</h3>

        <ol>
          <li>
            GIVE welcomes and accepts Applicants who are open and willing to learn about,
            experience, and show respect towards the local culture in the host country and
            communities where Programs are located.
          </li>

          <li>
            Any persons who are 15-years of age or older may apply. GIVE offers trips for various
            age groups. Participants must meet the minimum age requirement for their trip by the day
            of their departure. GIVE welcomes both students and non-students.
          </li>

          <li>
            Participants who are under the age of 18 must have a parent or guardian’s signature on
            the trip registration forms.
          </li>

          <li>
            All Participants must be physically, mentally, and medically capable of participating in
            all projects and activities included in the program. GIVE may require a medical form and
            doctor’s release form in some circumstances.
          </li>
        </ol>

        <h3>ACCEPTANCE PROCEDURES</h3>

        <ol>
          <li>
            Each Participant must complete and submit the GIVE Application. This does not commit or
            bind Applicants to GIVE Programs; each Applicant must be accepted before they are
            eligible to participate in GIVE Programs.
          </li>

          <li>
            GIVE will contact each Applicant to inform them of his/her a) acceptance into the
            program b) non-acceptance, or c) pending application due to a need for more information.
          </li>

          <li>
            If accepted, GIVE will notify the Applicant by email and include instructions regarding
            the completion of the GIVE Program Agreement.
          </li>

          <li>
            The GIVE Program Agreement must be completed and submitted through the Applicant’s
            Volunteer Profile with a non-refundable deposit for all trip(s) and add-on(s). The
            deposit does not expire; it is good for life. Refer to our cancellation policy below for
            additional details.
          </li>

          <li>
            Participants can select their Program on a first-come, first-served basis in the order
            that their GIVE Program Agreement and deposit(s) are received.
          </li>

          <li>
            If a Participant’s trip preferences change from the original departure date, the
            Participant may request to transfer the dates of their GIVE Program. The Participant
            must contact the GIVE office to confirm new Program dates (subject to space
            availability) and GIVE will complete the transfer. Transfer requests are subject to the
            cancellation policies listed below.
          </li>
        </ol>

        <h3>PRIVACY POLICY</h3>
        <p>
          GIVE respects and is committed to protecting your privacy and we appreciate your trust.
          When you sign up, apply, or complete GIVE’s registration form, you give us certain
          information (such as name and email address). Upon making a purchase, we collect payment
          information, contact information, and details of what you bought. The information you
          provide is used only by GIVE to respond to your inquiries and contact you about the
          products/services on our site in which you have expressed interest.
        </p>

        <h3>DEPOSITS</h3>

        <p>
          The trip deposit (and add-on deposit(s) if applicable) and GIVE Program Agreement, bearing
          a Participant or guardian’s signature, if necessary, must be submitted to participate in a
          GIVE Program. The trip deposit and add-on deposit(s) are non-refundable but good for life.
          Deposit and add-on deposit(s) cannot be transferred to a different individual.
        </p>
        <p>
          These monies permit GIVE to execute and provide: customer support, trip preparations,
          maintain programs annually while GIVE is not operating trips, make necessary reservations
          and arrangements, and confirm the Participant’s commitment to participate in the Program.
          GIVE will reserve the Participant’s Program placement dates upon receipt of the
          non-refundable deposit(s) and completed Agreement (subject to availability). Participant
          payments—including deposits, installments, and final balances—support operational needs
          year-round (e.g., staffing, program logistics, safety/compliance, and community impact)
          and are subject to GIVE’s cancellation, refund, and travel credit policies in these Terms.
        </p>

        <h3>FINANCIAL DUE DATES</h3>

        <p>
          Any and all payments associated with GIVE Program costs are due to GIVE on or before
          80-days prior to a Participant’s departure date. If a participant registers less than
          80-days before the trip, we will mutually agree on new deadlines. All payments must be
          received prior to departure. GIVE will provide Participants with a payment summary and
          display any balance due via the GIVE Profile. Full payment is due 80 days prior to a
          Participant’s departure date and GIVE charges a $50.00 fee for late payments.
        </p>
        <p>
          If GIVE does not receive full payment 80 days prior to departure and no prior arrangements
          have been made with GIVE, then GIVE will (1) assume the Participant has canceled their
          GIVE Program and (2) charge a $150.00 late cancellation fee. Once canceled, Participant’s
          placement for the GIVE Program and/or specific departure date is not guaranteed, even if a
          Participant becomes reinstated until final payment is received. For third-party hosted
          programs or private trips, the third-party or private trip terms and due dates supersede
          these terms. GIVE reserves the right to move a Participant’s Program dates for the GIVE
          Program within a reasonable amount of time per GIVE’s discretion.
        </p>
        <p>
          Trip Document Deadlines: All required travel documents are due 90 days before your trip
          start date. If you register within 90 days of your trip start date, you must submit the
          required documents within 30 days of your registration date. All travel documents must be
          received and reviewed to be eligible to join your trip. A $50 fee applies to late
          documents past the stated or pre-approved deadlines.
        </p>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <h2>What’s Included In Your Trip Cost</h2>
        <div className="col-md-6">
          <h3>GIVE’S PROGRAM INCLUDES</h3>
          <ul>
            <li>All accommodations during the Participant’s specified GIVE Program dates</li>
            <li>
              At least three (3) meals per day on all trips and add-ons, except on arrival and
              departure days, when included meals will be based on flight arrival and departure
              times
            </li>
            <li>All cultural and adventure activities listed on program itinerary</li>
            <li>National/local park fees</li>
            <li>All Program ground and water transportation in the host country</li>
            <li>All organization and associated fees charged in the host country</li>
            <li>Orientation(s) in host country</li>
            <li>Program management and program arrangements</li>
            <li>Administration and recruitment costs</li>
            <li>Dedicated and trained GIVE and local guides</li>
            <li>GIVE program overview, packing list, and trip preparation information</li>
            <li>All materials, staffing, and requirements to complete the volunteer initiatives</li>
            <li>To see everything that’s included, click here!</li>
          </ul>
        </div>
        <div className="col-md-6">
          <h3>GIVE’S PROGRAM COST DOES NOT INCLUDE:</h3>
          <ul>
            <li>
              All air transportation to and within the host country and all other associated air
              taxes, ticket fees, and any country departure taxes
            </li>
            <li>
              All transportation and accommodation costs prior to or subsequent to the Participant’s
              program dates
            </li>
            <li>Medical and travel/trip cancellation insurance (required)</li>
            <li>Passports, travel visas (where necessary) and any vaccinations or medications</li>
            <li>
              Any additional, optional activities available for Participants not listed on program
              itinerary
            </li>
            <li>Academic or Internship credit</li>
            <li>Gratuities</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <h2>CANCELLATION AND REFUND POLICY</h2>
        <h3>CANCELLATION NOTICE</h3>
        <p>
          If a Participant chooses not to attend a GIVE Program, Participants must inform GIVE HQ in
          writing via e-mail or mail with confirmation receipt by GIVE. No verbal cancellations will
          be accepted. Any and all monies cannot be transferred to a different Participant. In
          addition to informing GIVE of the cancellation, Participants must also inform their travel
          insurance provider, flight booking agent, or airfare provider of the cancellation. If the
          reason for cancellation falls within the covered benefits of the Participant’s Trip
          Cancellation and Interruption Insurance policy, the participant must first contact the
          insurance provider and file a claim. If the Participant’s insurance claim is denied, the
          Cancellation Policy below will apply.
        </p>
        <p>
          Since GIVE is liable to 3rd party vendors for financial commitments made on behalf of
          Participants for necessary program arrangements prior to departure, upon GIVE’s receipt of
          a Participant’s written cancellation, Participants will incur cancellation charges
          associated with expenses and costs suffered by GIVE for the Participant’s Program. The
          date of cancellation is defined as the date that GIVE received the Participant’s written
          cancellation notification.
        </p>
        <p>
          Trip Transfers: GIVE offers flexible trip transfers and payments convert to a
          nonrefundable travel credit once transferred. All transfers are subject to availability
          and the cancellation timetable below. Transfers less than 80 days prior to the trip start
          date incur a $150 transfer fee. Any trip payments not utilized within 2 years of the
          payment date convert to a good-for-life travel credit for any available GIVE trip
          location. For programs hosted by third parties or private trips, the host’s policies
          supersede GIVE’s terms.
        </p>

        <h3>CANCELLATION DATES & CORRESPONDING FEES</h3>
        <h4>IF YOU CANCEL YOUR TRIP WITH…</h4>

        <p>
          All trip cancellations less than 80-days before the trip start date incur a $150 late
          cancellation fee. This $150 fee will be deducted from the remaining balance of the
          canceled trip or reinstate the non-refundable deposit(s) toward a future trip. The term
          "deposit(s)" includes any and all trip deposit(s) and add-on deposit(s).
        </p>
        <p>
          <strong>80 days or more prior to departure:</strong>&nbsp;All deposit(s) are
          non-refundable and non-transferable, but good for life!
          <br />
          <strong>79 to 70 days prior to departure:</strong>&nbsp;Loss of 25% of the total program
          cost, excluding non-refundable deposit(s), and a $150 late cancellation fee.
          <br />
          <strong>69 to 50 days prior to departure:</strong>&nbsp;Loss of 50% of total program cost,
          excluding non-refundable deposit(s), and a $150 late cancellation fee.
        </p>
        <p>
          <strong>49 to 31 days prior to departure:</strong>&nbsp;Loss of 75% of total program cost,
          excluding non-refundable deposit(s), and a $150 late cancellation fee.
          <br />
          <strong>30 days or less prior to departure:&nbsp;</strong>Loss of 100% of total program
          cost, including non-refundable deposit(s).
          <br />
          <strong>Failure to show up:</strong>&nbsp;Loss of 100% of total program cost, including
          non-refundable deposit(s).
        </p>
        <p>
          Please note that the above cancellation policy does not include airfare as travelers are
          subject to the airlines’ terms and conditions. Any cancellation eligible for cash refunds
          will be processed at the end of the GIVE scheduled program term per the traveler’s
          request. There will be a $75 administrative fee to process refunds. If cancellation
          reasons are within the terms of a Participant’s Trip Cancellation and Interruption
          Insurance Policy, the Participant must file a claim with their insurer.
        </p>
        <p>
          Payment Options: Participants may choose from Pay in Full, Buy Now Pay Later (BNPL),
          Recurring Payment Plan, or Standard Payment Plan. Payments made under Pay in Full, BNPL,
          and Recurring Payment Plan are non-refundable and valid only as lifetime travel credit.
          Under the Standard Payment Plan, remaining balance payments (excluding deposit[s]) may be
          eligible for partial cash refunds based on the timetable above or may be converted to
          lifetime travel credit.
        </p>
        <p>
          Travel Credit Policy: At GIVE’s discretion, non-refundable travel credits may be issued in
          lieu of a refund. Credits are valid for life, issued to the original Participant,
          redeemable dollar-for-dollar toward the base cost of future GIVE programs,
          non-transferable unless authorized in writing by GIVE, not redeemable for cash, and
          subject to availability, program pricing, and GIVE’s offerings at redemption.
        </p>

        <h3>CANCELLATION DUE TO FORCE MAJEURE</h3>
        <h4>IF GIVE CANCELS OR POSTPONES YOUR TRIP…</h4>

        <p>
          GIVE will not be responsible for any trip delay, alteration, cancelation, or failure to
          perform its obligations pursuant to these Terms if caused by Force Majeure or forces of
          nature, foreseeable or unforeseeable events, or circumstances beyond its reasonable
          control. Such circumstances include but are not limited to acts of God, lightning strikes,
          earthquakes, floods, storms, explosions, fires, and any natural disaster; pandemics or
          epidemics; acts of war, protests, terrorism, riots, civil commotion, malicious damage,
          sabotage and revolution; and strikes.
        </p>

        <h3>PROGRAM ITINERARY</h3>
        <p>
          GIVE reserves the right to modify and/or change the Program itinerary without notice.
          Every reasonable effort will be employed to operate the Program as planned. Should
          unforeseen events and conditions require the itinerary to be altered or cancelled, GIVE
          reserves the right to do so for the safety and best interest of Participants. If these
          issues occur and GIVE is forced to cancel a Program, GIVE will attempt to rebook the
          Participant to an alternate program, subject to conditions and availability, and Force
          Majeure Terms and Conditions will apply.
        </p>
        <h3>LEGAL DISPUTE</h3>
        <p>
          In the event that a dispute shall arise between parties to the Program Agreement with
          regard to any of the provisions or the performance of any Terms and Conditions of the
          Agreement, Participant agrees that the exclusive venue for dispute resolution shall be
          King County Superior Court in Seattle, Washington.
        </p>

        <h3>TRAVEL/TRIP CANCELLATION INSURANCE</h3>
        <p>
          All Participants are required to secure travelers insurance with trip cancellation, trip
          interruption, and medical coverage for the duration of the GIVE Program. Participants must
          select a policy that meets GIVE’s required minimum standards and their individual needs
          (e.g., pre-existing conditions, coverage limits, travel duration). It is important that
          Participants thoroughly read and review any insurance policy, specifically in regard to
          cancellation, trip interruption, and medical circumstances. GIVE is not responsible for
          any travel/trip insurance actions, exclusions, or omissions. GIVE requires Participants to
          submit their proof of travel/trip cancellation insurance to the GIVE office by the
          document deadline.
        </p>

        <h3>MEDICAL INSURANCE</h3>
        <p>
          GIVE requires all volunteer Participants to advise the GIVE office of any pre-existing or
          current medical condition and/or allergies either on the GIVE medical form or by e-mail.
          GIVE is not responsible for any omissions in regard to the volunteer Participants’ medical
          information.
        </p>

        <h3>FLIGHTS</h3>

        <p>
          <strong>
            GIVE strongly recommends all Participants purchase flights through GIVE’s dedicated
            flight providers to/from the host country(s) or program.
          </strong>
          &nbsp;This ensures the Participant meets GIVE’s arrival and departure requirements and
          smooth travel with our dedicated partner’s support. If Participants cannot book through
          our recommended providers, then they must contact GIVE regarding alternate travel plans.
        </p>

        <h3>ADDITIONAL DOMESTIC TRANSPORTATION IN HOST COUNTRY</h3>
        <p>
          Ground and water transportation within the host country is provided by GIVE within the
          confines of the GIVE itinerary; any additional travel requirements or arrangements outside
          of the GIVE itinerary must be paid for by the Participant. Air transportation to/from GIVE
          trips and/or add-ons is not included in the trip cost.
        </p>

        <h3>ORIENTATION (Mandatory)</h3>
        <p>
          GIVE provides orientation meeting(s) in the Participant’s host country(s) as well as an
          interactive debriefing seminar before the end of the excursions. The orientation(s) are
          conducted by GIVE Guides in the host country(s) with the purpose of preparing
          Participants. The final debriefing seminar is an interactive meeting meant to gain insight
          from our Participants about our Programs and volunteer initiatives.
        </p>

        <h3>VOLUNTEER PROJECT</h3>
        <p>
          GIVE will provide information on Volunteer Initiatives to Participants via email prior to
          their departure date. Information sent to Participants will describe project goals, host
          organization background and facts, accommodations, meals, volunteer tasks, suggested
          reading material, a packing list, health and safety considerations, and more.
        </p>
        <p>
          All GIVE groups will be accompanied by a GIVE Guide to collaborate with the host
          organization, facilitate group discussions, supervise volunteer activities and promote the
          Participants’ safety. GIVE reserves the right to modify volunteer projects without notice,
          subject to unforeseen conditions.
        </p>

        <h3>ADVENTURE TOUR</h3>
        <p>
          Participants will have the option to add on activities during their Adventure Tour. These
          add-on activities are additional to the Program cost and can be purchased during the
          Program at the Participant’s discretion. Participants must consult with their physician
          regarding scuba diving health precautions. GIVE reserves the right to modify Adventure
          Tours without notice, subject to unforeseen conditions.
        </p>

        <h3>MEALS ON THE GIVE PROGRAM</h3>
        <p>
          Participants are encouraged to try local foods to authenticate their experience. During
          the Program, GIVE will provide at least three (3) meals a day, excluding arrival and
          departure days as included meals will be based on flight arrival and departure times.
          Participants must inform GIVE HQ of dietary needs either in their application or via
          email. Vegetarians and vegans can be accommodated. GIVE can accommodate most but not all
          dietary needs; in certain cases, Participants may need to supplement the included meals at
          their own expense. Participants with food allergies (or other allergies) must ensure that
          GIVE is aware of such allergies and the severity of the allergies.
        </p>
      </div>
    </div>
  </div>
);

ApplicationTermsAndConditionsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default ApplicationTermsAndConditionsModal;
